// Control styles shared by the Watchdog list and its dialogs, so a segmented group or a plain
// button reads the same wherever it appears.
export const srOnly = { position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' } as const;
export const plainButton = { font: 'inherit', cursor: 'pointer', '&:focus-visible': { outline: '2px solid #6366F1', outlineOffset: 2 } } as const;

export const pressable = (pressed: boolean) => ({
  ...plainButton,
  fontSize: '0.8125rem',
  fontWeight: pressed ? 700 : 500,
  whiteSpace: 'nowrap',
  border: 0,
  px: '11px',
  py: '6px',
  bgcolor: pressed ? '#F8FAFC' : '#FFFFFF',
  color: pressed ? '#0F172A' : '#475569',
  '&:hover': { bgcolor: pressed ? '#F8FAFC' : 'rgba(100,116,139,0.06)' },
  '&:focus-visible': { outline: '2px solid #6366F1', outlineOffset: -2 },
});
export const buttonGroup = { display: 'inline-flex', border: '1px solid #CBD5E1', borderRadius: '6px', overflow: 'hidden', '& > button + button': { borderLeft: '1px solid #CBD5E1' } } as const;
